import { isEmpty } from 'lodash';
import { useContext } from 'react';
import { OnboardingContext } from './OnboardingContext';

export const useOnboardingState = () => {
  const context = useContext(OnboardingContext);

  if (isEmpty(context)) {
    throw new Error(
      'useOnboardingState must be used within a OnboardingProvider'
    );
  }

  return context;
};
